import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  ADMIN_DASHBOARD_PATH,
  EMPLOYER_DASHBOARD_MANAGE_JOBS_PATH,
  JOB_SEEKER_DASHBOARD_PROFILE_PATH,
} from "../api/routeConstants";
import { useHistory } from "react-router-dom";

export default function useRedirectAuth({ shouldExecute = true }) {
  const history = useHistory();

  const { authenticated } = useSelector((state) => state.auth);
  const { currentUserAccount } = useSelector((state) => state.account);

  // need to toggle a flag to run as it does not on first render
  const [rerun, setRerun] = useState(false);

  useEffect(() => {
    if (!shouldExecute) return;
    if (!authenticated) return;
    if (currentUserAccount?.isEmployer) {
      history.push(EMPLOYER_DASHBOARD_MANAGE_JOBS_PATH, []);
      setRerun(!rerun);
    } else if (currentUserAccount?.isJobSeeker) {
      history.push(JOB_SEEKER_DASHBOARD_PROFILE_PATH);
      setRerun(!rerun);
    } else if (currentUserAccount?.isAdmin) {
      history.push(ADMIN_DASHBOARD_PATH);
      setRerun(!rerun);
    }
  }, [authenticated, currentUserAccount, history, rerun, shouldExecute]);
}
